import CUSTOM_NAVS from "./constants/customNavs"

export function currentLocation({ location }) {
  if (location?.pathname) {
    return location.pathname
  } else if (typeof window !== "undefined") {
    return window.location.pathname
  } else {
    return null
  }
}

export function isArticlePage({ location }) {
  return currentLocation({ location }).includes("articles") || currentLocation({ location }).includes("blog")
}

export function isAdditionalCoursePage(location, slug) {
  return currentLocation({ location }).includes(slug)
}

export function getCustomNavKey({ location }) {
  const path = currentLocation({ location })
  if (path !== null) {
    const navKey = Object.keys(CUSTOM_NAVS).find((slug) => path.includes(slug))
    return navKey
  } 
  
  return null
}